import { ConsultaPadrao } from "../../components/ConsultaPadrao";
import { model_usuario } from "../../models";
import styled from "styled-components";
import { TreeGroup } from "./GruposUsuario";
import { AplicativosUsuario } from "./AplicativosUsuario";
import { useRef } from "react";
import { MonitorSmartphone, UserLock } from 'lucide-react';
import Acessos from "./Acessos";

//import { useAuth } from "../../contexts/AuthProvider/useAuth";
//import { Privilegio } from "../../contexts/AuthProvider/types";

const ContainerDetail = styled.div`
    padding: 1rem;
`

export const Usuario = () => {
    //const auth = useAuth();
    const refTable = useRef<any>(null);
    const refModalApp = useRef<any>(null);
    const refAcessos = useRef<any>(null)

    const columns = [
        { field: 'usucodigo', header: 'Código' },
        { field: 'usunome', header: 'Nome' },
        { field: 'usuemail', header: 'E-mail' },
        { field: 'aplicativos', header: 'Aplicativos Liberados' },
        { field: 'usuativo', header: 'Ativo' },
        { field: 'functions', style: { minWidth: '4rem', width: '4rem' } }
    ];

    const details = (row: any) => {
        return (
            <ContainerDetail>
                <TreeGroup usucodigo={row.usucodigo} />
            </ContainerDetail>
        )
    }

    function functions(row: any) {
        let _result = [];

        //  if (auth.privilegio === Privilegio.Admnistrador)
        _result.push({ click: () => refAcessos.current.openModal(row), icon: <UserLock />, color: 'var(--primary-color)' })
        _result.push({ click: () => refModalApp.current.openModal(row), icon: <MonitorSmartphone />, color: 'var(--primary-color)' })

        return _result;
    }

    return (
        <>
            <ConsultaPadrao ref={refTable} model={model_usuario} columns={columns} sortField="usunome" details={details} functions={functions} disableedit />
            <AplicativosUsuario ref={refModalApp} onRefresh={() => refTable.current.refresh()} />
            <Acessos ref={refAcessos} onRefresh={() => refTable.current.refresh()} />
        </>
    )
}